import React from 'react';
import type { UserDetailsResponse } from '../../schemas/validation';

interface OverviewCardsProps {
  statistics: UserDetailsResponse['data']['statistics'];
}

export const OverviewCards: React.FC<OverviewCardsProps> = ({ statistics }) => {
  const cards = [
    {
      label: 'Total Sites',
      value: statistics.totalSites,
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9"
        />
      ),
    },
    {
      label: 'Published Sites',
      value: statistics.publishedSites,
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      ),
    },
    {
      label: 'Total Pages',
      value: statistics.totalPages,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        />
      ),
    },
    {
      label: 'Media Files',
      value: statistics.totalMedia,
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      ),
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards.map(card => (
        <div key={card.label} className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div
                className={`w-8 h-8 ${card.bgColor} rounded-md flex items-center justify-center`}
              >
                <svg
                  className={`w-5 h-5 ${card.iconColor}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {card.icon}
                </svg>
              </div>
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">{card.label}</dt>
                <dd className="text-lg font-medium text-gray-900">{card.value}</dd>
              </dl>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
